var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.619 5.41c0 .191.082.381.228.521l4.19 4.183a.704.704 0 00.501.216c.4 0 .692-.286.692-.673a.674.674 0 00-.21-.501L4.593 7.708l-1.84-1.682 1.478.09h7.694c.419 0 .71-.293.71-.705 0-.42-.291-.711-.71-.711H4.23l-1.472.089 1.834-1.683L6.021 1.66a.674.674 0 00.209-.501c0-.387-.292-.673-.692-.673a.73.73 0 00-.52.228l-4.17 4.17a.731.731 0 00-.23.528z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.72cb45b19265d7fe98c785e5e1d8c42a.svg";
export { ForwardRef as ReactComponent };